/*
 * JoinUs.jsx
 * Created by Destin Frasier on 05/02/18
 */

import React from 'react';

export default class JoinUs extends React.Component {
    render() {
        return (
            <ul className="nav-footer-list">
                <li>
                    <a href="/get-involved">Get Involved</a>
                </li>
                <li>
                    <a href="/use-our-data">Use Our Data</a>
                </li>
            </ul>
        );
    }
}
